import React from "react";
import styles from "./style.module.css";

import NumberFormat from "react-number-format";

import { Button, ButtonGroup } from "react-bootstrap";

import WaterfallMatrix from "components/ValueMatrix/WaterfallMatrix";
import Waterfall from "components/Waterfall/Waterfall";

export default class ModelTileSuccess extends React.PureComponent {
  state = {
    opacity: 0
  };

  componentDidMount() {
    setTimeout(() => this.setState({ opacity: 1.0 }), 150);
  }

  renderInfo(label, num, pct) {
    return (
      <div className={styles.modelInfo}>
        <div className={styles.infoMsg} style={{ width: "100px" }}>
          {label}
        </div>
        <div className={styles.infoNum}>{num}</div>
        <div className={styles.infoPct}>{pct}</div>
      </div>
    );
  }

  render() {
    const {
      model,
      hideCosts,
      processLimit,
      isNoClick,
      truePositiveLabel,
      trueNegativeLabel,
      falsePositiveLabel,
      falseNegativeLabel,
      isQuickRun,
      isTwoMinuteRun,
      scoreCount,
      onClick,
      isFeatured,
      style,
      updateFeatureSelection,
      netImpactLabel
    } = this.props;

    const maxIteration = model.maxIteration;
    const metrics = model.metrics;
    const isContinuous = metrics && Object.keys(metrics).length > 0;

    return (
      <div
        className={
          styles.successModel +
          " " +
          (isNoClick === true ? styles.modelNoClick : isFeatured ? styles.featuredModel : styles.sModel)
        }
        style={{
          border: "none",
          background: "white",
          margin: "0px",
          padding: "0px",
          marginTop: "10px",
          boxShadow: "none"
        }}
        onClick={onClick ? () => onClick() : () => {}}
        id={model ? model.id : ""}
      >
        <div className={styles.modelGraph}>
          <Waterfall bars={model.bars} totalLabel={isContinuous ? "Absolute Error" : netImpactLabel} />
          {/*
          <WaterfallMatrix
            maxIteration={model.maxIteration}
            label={model.label}
            hideCosts={hideCosts}
            truePositiveLabel={truePositiveLabel}
            trueNegativeLabel={trueNegativeLabel}
            falsePositiveLabel={falsePositiveLabel}
            falseNegativeLabel={falseNegativeLabel}
            isQuickRun={isQuickRun}
            metrics={model.metrics}
            isMetrics={model.metrics !== undefined && Object.keys(model.metrics).length > 0}
          />
        */}
        </div>
        <div className={styles.modelHolder}>
          <div className={styles.modelLabel}>
            <div className={styles.mLabel}>{model.label}</div>
            {scoreCount > 0 && (
              <div className={styles.scoreCount}>
                {"(" + scoreCount + " scored dataset" + (scoreCount > 1 ? "s" : "") + ")"}
              </div>
            )}
          </div>
          {maxIteration.truePositive !== undefined &&
            this.renderInfo(
              "Processed",
              Math.round(maxIteration.truePositive + maxIteration.falsePositive),
              (((maxIteration.truePositive + maxIteration.falsePositive) / processLimit) * 100).toFixed(1) +
                "% of capacity"
            )}
          {maxIteration.truePositive !== undefined &&
            this.renderInfo(
              truePositiveLabel,
              Math.round(maxIteration.truePositive),
              maxIteration.truePositive + maxIteration.falsePositive === 0
                ? 0
                : (
                    (maxIteration.truePositive / (maxIteration.truePositive + maxIteration.falsePositive)) *
                    100
                  ).toFixed(1) + "% of processed"
            )}
          {maxIteration.truePositive !== undefined &&
            this.renderInfo("Accuracy", undefined, (maxIteration.accuracy * 100).toFixed(1) + "%")}
          {maxIteration.precision !== undefined &&
            model.id !== "Current State" &&
            this.renderInfo("Precision", undefined, (maxIteration.precision * 100).toFixed(1) + "%")}
          {maxIteration.recall !== undefined &&
            model.id !== "Current State" &&
            this.renderInfo("Recall", undefined, (maxIteration.recall * 100).toFixed(1) + "%")}
          {model &&
            model.metadata &&
            model.metadata.log_loss !== undefined &&
            model.id !== "Current State" &&
            this.renderInfo("Log Loss", undefined, model.metadata.log_loss.toFixed(4))}
          {metrics.mean_absolute_error !== undefined &&
            this.renderInfo(
              "Mean Absolute Error",
              undefined,
              <NumberFormat
                value={metrics.mean_absolute_error.toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
              />
            )}
          {metrics.overImpact !== undefined &&
            this.renderInfo(
              "Overestimate Relative Cost",
              undefined,
              <NumberFormat value={metrics.overImpact.toFixed(2)} displayType={"text"} thousandSeparator={true} />
            )}
          {metrics.underImpact !== undefined &&
            this.renderInfo(
              "Underestimate Relative Cost",
              undefined,
              <NumberFormat value={metrics.underImpact.toFixed(2)} displayType={"text"} thousandSeparator={true} />
            )}
          {metrics.overImpact === undefined &&
            metrics.sum_over_predict !== undefined &&
            this.renderInfo(
              "Sum of Overestimates",
              undefined,
              <NumberFormat value={metrics.sum_over_predict.toFixed(2)} displayType={"text"} thousandSeparator={true} />
            )}
          {metrics.underImpact === undefined &&
            metrics.sum_under_predict !== undefined &&
            this.renderInfo(
              "Sum of Underestimates",
              undefined,
              <NumberFormat
                value={metrics.sum_under_predict.toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
              />
            )}
          <div style={{ height: "10px" }} />
          {isQuickRun !== true &&
            this.renderInfo(
              metrics.overImpact ? "Total Cost" : netImpactLabel,
              undefined,
              <NumberFormat
                value={
                  metrics.overImpact
                    ? Math.round(metrics.overImpact + metrics.underImpact)
                    : Math.round(maxIteration.showConstraint === true ? maxIteration.constraintROI : maxIteration.roi)
                }
                displayType={"text"}
                thousandSeparator={true}
              />
            )}
          {isQuickRun !== true &&
            metrics.overImpact === undefined &&
            !isTwoMinuteRun &&
            maxIteration.improvement &&
            this.renderInfo(
              "Improvement",
              undefined,
              <NumberFormat
                value={Math.round(maxIteration.improvement)}
                displayType={"text"}
                thousandSeparator={true}
              />
            )}
          {isQuickRun !== true && maxIteration.showConstraint === true
            ? this.renderInfo(
                "Unconstrained " + netImpactLabel,
                undefined,
                <NumberFormat value={Math.round(maxIteration.roi)} displayType={"text"} thousandSeparator={true} />
              )
            : this.renderInfo(".")}
        </div>
      </div>
    );
  }
}
